var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Create Organization")]),_c('v-container',[_c('OrganizationForm',{attrs:{"type":"CREATE","organization":_vm.organization}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }